export enum ErrorLevel {
  debug = 'debug',
  info = 'info',
  success = 'success',
  warning = 'warning',
  error = 'error',
  fatal = 'fatal',
}

// ? level was deprecated from IErrorType in 6.5
// any error (instance) w/o a levelOverride is assumed to be an error (level) by default
export const DEFAULT_ERROR_LEVEL = ErrorLevel.error;

export enum ErrorVisibility {
  CustomerSupport = 'cs',
  Engineering = 'eng',
}

export const ERROR_MSGS = {
  CONTACT_SUPPORT:
    'Please contact support via the Help Center and/or try again.',
};

export enum ServerErrorCategory {
  auth = 'auth',
  customerApi = 'customer-api',
  dataApi = 'data-api',
  deprecation = 'deprecation',
  detection = 'detection',
  express = 'express',
  hitModel = 'hitModel',
  hitter = 'hitter',
  integration = 'integration',
  job = 'job',
  liveboard = 'liveboard',
  machine = 'machine',
  machineModel = 'machineModel',
  matching = 'matching',
  mongo = 'mongo',
  other = 'other',
  pitch = 'pitch',
  pitchList = 'pitchList',
  postgres = 'postgres',
  plotting = 'plotting',
  python = 'python',
  realTimeApi = 'real-time-api',
  redis = 'redis',
  s3 = 's3',
  safety = 'safety',
  session = 'session',
  statsApi = 'stats-api',
  training = 'training',
  user = 'user',
  video = 'video',
  ws = 'ws',
}

export enum ErrorDepartment {
  DS = 'DS', // data science
  FW = 'FW', // firmware
  HW = 'HW', // hardware
  Vision = 'Vision', // vision
  Web = 'Web', // web
}
